export default ({ http }) => ({
  //获取图形验证码
  getVerifycode() {
    return http.get("/code/image");
  },
  // 登录
  login(data) {
    return http.post("/doLogin", data, {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8"
      }
    });
  },
  //更新原密码
  updatePassword(data) {
    return http.post("/user/updatePassword", data);
  },
  // 登出
  logout(data = {}) {
    return http.get("/doLogout", data);
  },

  //---------电子印章注册---------
  //状态查询
  getSubmitStatus() {
    return http.get("/sealRegister/checkSubmitStatus");
  },
  //证件类型下拉框
  getCertificateType() {
    return http.get("/sealRegister/getIdentityType");
  },
  // //授权书模板下载
  // downloadTemplate() {
  //   window.$app.getForm("/sealRegister/downloadTemplate");
  // },
  //提交注册
  registerSubmit(data) {
    return http.upload("/sealRegister/submitInfo", data);
  },

  //---------资料修改---------
  //获取资料详情--跳转进来后请求展示的数据
  getInformationDetails() {
    return http.get("/modifiedUserData/getUserData");
  },
  //照片查看,transactorPhotoFront:经办人身份证正面,transactorPhotoReverse:经办人身份证反面,photo:企业证件照片
  //data是id信息，资料修改首页不需要，历史修改记录里需要传对应的修改id
  getCertificateImg(type, data) {
    return http.post(`/modifiedUserData/getUserDataDetail/${type}`, data, {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8"
      }
    });
  },
  //下载经办人授权书和用户公司名变更说明书,经办人授权书 authorization, 公司名变更说明书 changeNameVerification
  downloadFile(type, id) {
    window.$app.getForm(`/modifiedUserData/getUserAuthorization/${type}`,{
      id
    });
  },
  //是否可以修改的状态查询
  getModifyStatus() {
    return http.get("/modifiedUserData/getUserStatus");
  },
  // //用户公司名变更说明书模版下载
  // downloadNamechangeTemplate() {
  //   window.$app.getForm("/modifiedUserData/downloadChangeNameVerificationTemplate");
  // },
  //提交修改
  modifySubmit(data) {
    return http.upload("/modifiedUserData/submitUserData", data);
  },
  //用户提交历史记录
  getModifyHistory(data) {
    return http.post("/modifiedUserData/userSubmitHistory", data);
  },

  //---------合同用印操作---------
  //待用印列表
  getWaitList() {
    return http.get("/contractSign/getContract");
  },
  //已用印列表
  getAlreadyList() {
    return http.get("/contractSign/getContractSealed");
  },
  //获取合同文件名列表
  getContractFilesList(data){
    return http.post("/contractSign/getUnsealContractFilesNameList",data);
  },
  //获取合同文件
  getContractFile(data) {
    return http.post("/contractSign/downloadUnsealContract",data);
  },
  //获取手机号
  getPhoneNum(){
    return http.get("/contractSign/getMobilePhone");
  },
  //获取验证码
  getCaptcha(data){
    return http.get("/contractSign/getCheckCode",data,{
      headers: {
        "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8"
      }
    });
  },
  //提交用印信息
  submitSealInfo(data) {
    return http.post("/contractSign/submitContract", data);
  },
  //获取用印位置描述
  getSealPositionList(data){
    return http.post("/contractSign/getInfoDescribe", data, {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8"
      }
    });
  },
  //下载用印归档文件
  downloadSealedContract(contractId) {
    window.$app.getForm("/contractSign/downloadSealedContract",{
      contractId
    });
  }
});



// WEBPACK FOOTER //
// ./src/server/api/common.js